import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16 5.334A4 4 0 0 0 12.228 8h7.545A4 4 0 0 0 16 5.334m0-2.667A6.67 6.67 0 0 0 9.467 8a4 4 0 0 0-3.945 3.508 3465 3465 0 0 0-1.485 12.135c-.25 2.096.786 3.548 2.04 4.415 1.19.824 2.626 1.177 3.591 1.27q.064.006.127.006h12.86c2.183 0 3.656-.894 4.497-2.178.784-1.197.917-2.577.82-3.496l-.002-.022-1.487-12.125A4 4 0 0 0 22.533 8 6.67 6.67 0 0 0 16 2.667m-6.509 8c-.673 0-1.24.501-1.322 1.168-.49 3.964-1.195 9.685-1.484 12.123-.106.89.263 1.46.91 1.908.687.476 1.61.729 2.268.801h12.792c1.365 0 1.961-.506 2.266-.972.36-.55.449-1.264.4-1.745l-1.485-12.112a1.333 1.333 0 0 0-1.323-1.171zm2.167 5.775a1.333 1.333 0 0 0-1.982 1.784c1.799 1.998 4.005 3.108 6.324 3.108s4.526-1.11 6.324-3.108a1.333 1.333 0 0 0-1.982-1.784c-1.4 1.556-2.927 2.225-4.342 2.225s-2.941-.669-4.342-2.225",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }